import type { SearchTermSuggestion } from './universalSearchTypes'

/** Placeholder used by the compact search field in the site header. */
export const SITE_HEADER_SEARCH_PLACEHOLDER = 'Search conditions, medications, labs, and more...'

/** Shorter variant for narrow screens, where the full placeholder would clip. */
export const SITE_HEADER_SEARCH_PLACEHOLDER_MOBILE = 'Search conditions, meds, labs...'

export const DEFAULT_TERM_SUGGESTIONS: SearchTermSuggestion[] = [
    { label: 'GLP-1’s', query: 'GLP-1' },
    { label: 'hair meds', query: 'hair meds' },
    { label: 'Weight loss', query: 'Weight loss' },
    { label: 'Prescription renewal', query: 'Prescription renewal' },
    { label: 'Dermatology', query: 'Dermatology' },
]

export const MEDICATIONS_TERM_SUGGESTIONS: SearchTermSuggestion[] = [
    { label: 'Prescription renewal', query: 'Prescription renewal' },
    { label: 'GLP-1’s', query: 'GLP-1' },
    { label: 'Zepbound (Tirzepatide)', query: 'Zepbound' },
    { label: 'Naltrexone', query: 'Naltrexone' },
    { label: 'Sertraline', query: 'Sertraline' },
]
